
import { InputAdornment, TextField } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import PropTypes from "prop-types";

const SearchMobileAppFilter = ({
  value = "",
  onSearch = () => {},
  placeholder = "Search...",
  size = "small",
  variant = "outlined",
  fullWidth = true,
  className = "purchase-search",
}) => {
  return (
    <TextField      
      value={value}
      onChange={(e) => onSearch(e.target.value)}
      placeholder={placeholder}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      className={className}
      InputProps={{
        "data-testid": "search-input",
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlinedIcon  style={{ color: "#212529" }}/>
          </InputAdornment>
        ),
      }}
    />
  );
};

SearchMobileAppFilter.propTypes = {
  value: PropTypes.string,
  onSearch: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default SearchMobileAppFilter;